
import { defineComponent, Ref, ref } from 'vue';

export default defineComponent({
  props: {
    title: { type: String, default: '' },
    hideViewAll: { type: Boolean, default: false },
    noHideAll: { type: Boolean, default: false },
  },
  emits: ['view-all', 'hide-all'],
  setup(props, { emit }) {
    const isViewAll: Ref<boolean> = ref(false);

    function viewAll(): void {
      isViewAll.value = true;
      emit('view-all');
    }

    function hideAll(): void {
      isViewAll.value = false;
      emit('hide-all');
    }

    return {
      isViewAll,
      viewAll,
      hideAll,
    };
  },
});
